import { injectable } from "inversify";
import AIRepository from "../../repositories/AIRepository";

interface props {
    aiRepository: AIRepository;
}

@injectable()
export class GetAIChatsUseCase {
    _aiRepository: AIRepository;

    constructor(_: props) {
        this._aiRepository = _.aiRepository;
    }

    public call = async (params: string): Promise<any> => {
        return await this._aiRepository.getAIChats(params);
    }
}

export const GetAIChatsUseCaseName = "GetAIChatsUseCaseName";
